import * as React from 'react';

import FileDicom16 from './FileDicom16';

export const fileDicom16 = () => <FileDicom16 />;

export default {
    title: 'Icon|Fill|FileDicom16',
    component: FileDicom16,
    parameters: {
        notes: "`import FileDicom16 from 'box-ui-elements/es/icon/fill/FileDicom16';`",
    },
};
